// extracted by mini-css-extract-plugin
export var link = "_uj-0";